var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenHighlightSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.262222 2.13771L2.44 4.34293C2.85778 4.76598 3.42222 5 4.01333 5L11.9911 5C12.5822 5 13.1467 4.76148 13.5644 4.34293L15.7378 2.13771C15.9067 1.9667 16 1.74167 16 1.50315V0H0V1.49865C0 1.73717 0.0933336 1.9667 0.262222 2.13321V2.13771ZM5 17.3281V10.6711C5 10.3005 5.29848 10 5.66667 10H10.3333C10.7015 10 11 10.3005 11 10.6711V15.1359C11 15.3967 10.85 15.6338 10.6153 15.7441L5.94859 17.9362C5.5066 18.1439 5 17.8191 5 17.3281ZM12.1667 6L3.83333 6C3.3731 6 3 6.44771 3 7L3 8C3 8.55229 3.3731 9 3.83333 9L12.1667 9C12.6269 9 13 8.55229 13 8V7C13 6.44772 12.6269 6 12.1667 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenHighlightSmall);
export default __webpack_public_path__ + "static/media/pen-highlight-small.b1b43d5a1ef6c9fa462f165526adaa81.svg";
export { ForwardRef as ReactComponent };